var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestart(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.956 12.311a5.642 5.642 0 001.046-.514l.793 1.079a6.96 6.96 0 01-1.519.738l-.32-1.303zM4.219 10.03l-.8 1.183c.281.371.603.708.951 1.017l.721-1.139a5.68 5.68 0 01-.872-1.061zM3.435 6C3.91 3.352 6.218 1.333 9 1.333A5.673 5.673 0 0114.667 7c0 1.542-.622 2.94-1.624 3.963l.798 1.085A6.972 6.972 0 0016 7c0-3.865-3.135-7-7-7-3.525 0-6.433 2.61-6.918 6H0l2.667 3.945L5.333 6H3.435zm3.83 6.383a5.606 5.606 0 01-1.105-.489l-.71 1.122c.459.273.95.493 1.467.655l.348-1.288zm2.395.242c-.56.065-.69.044-1.082.014l-.355 1.315c.63.07 1.107.061 1.757-.03l-.32-1.299z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default "/_resources/themes/app/dist/images/Restart.svg";
export { SvgRestart as ReactComponent };